"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getErrorMessage(e) {
    if (e) {
        if (e.graphQLErrors && e.graphQLErrors.length > 0) {
            return e.graphQLErrors
                .map(({ cause, message }) => cause || message || "unknown error")
                .join(", ");
        }
        else {
            return e.message || e.cause || "unknown error";
        }
    }
    else {
        return "unknown error";
    }
}
exports.getErrorMessage = getErrorMessage;
function returnError(graphQLErrors, message) {
    if (graphQLErrors && graphQLErrors.length > 0) {
        return graphQLErrors.map(({ cause, message }) => cause || message || "unknown error");
    }
    else {
        return [message || "unknown error"];
    }
}
exports.returnError = returnError;
function userUrl(username) {
    return `https://directory.prod.atl-paas.net/employees/${username}`;
}
exports.userUrl = userUrl;
function openExternalLink(to, target) {
    track("open external link", { category: "info", url: to });
    window.open(to, target);
}
exports.openExternalLink = openExternalLink;
function servicePath(id) {
    return `/services/${id}`;
}
exports.servicePath = servicePath;
function categoryPath(id) {
    return `/categories/${id}`;
}
exports.categoryPath = categoryPath;
// tslint:disable-next-line
function compose(...funcs) {
    const functions = funcs.reverse();
    return function (...args) {
        const [firstFunction, ...restFunctions] = functions;
        let result = firstFunction.apply(null, args);
        restFunctions.forEach(fnc => {
            result = fnc.call(null, result);
        });
        return result;
    };
}
exports.compose = compose;
function updateURLParams(currentParams, newParams) {
    const urlParams = new URLSearchParams(currentParams);
    for (const param of newParams) {
        if (param.val && param.val.trim()) {
            urlParams.set(param.name, param.val.trim());
        }
        else {
            urlParams.delete(param.name);
        }
    }
    return urlParams.toString().length > 0 ? `?${urlParams.toString()}` : "";
}
exports.updateURLParams = updateURLParams;
var graphql_1 = require("./graphql");
exports.AutoMockedProvider = graphql_1.AutoMockedProvider;
